import React from "react";
import "../../assets/styles/components.css";
import imgLock from "../../assets/images/lock.svg";
import rightArrowBlue from "../../assets/images/rightArrowBlue.svg";
import { gtmConstant } from "../../constants/gtmConstant";
import {sendDataLayer} from "../../../src/actions/gtmService";
export default class BottomText extends React.Component {
  render() {
    let { onGoSecretCodeDetails } = this.props;
    return (
      <div className="bottom-text main-warp">
        <div className="bottom-text-warp">
          <div className="inner">
            <span className="title">חדש!</span>
            <span className="msg">מהיום ניתן לבחור קוד סודי שקל לזכור</span>
            <a
              className="link"
              onClick={(e) => {
                e.preventDefault();
                sendDataLayer(gtmConstant.SecretCode.FUNNEL_CLICK, {
                  process_type: gtmConstant.SecretCode.PROCESS_NAME,
                  step_title: gtmConstant.SecretCode.STEP_TITLE.END,
                  step_number: 3,
                  click_text: "לפרטים", 
                });
                onGoSecretCodeDetails();
              }}
              href="javascript:void(0)"
            >
              <span>לפרטים</span>
              <img src={rightArrowBlue} />
            </a>
          </div>
          <img alt="בחירת קוד סודי שקל לזכור" src={imgLock}></img>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/BottomText.jsx